import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { IWorkoutApi } from './interfaces/workout-abstract.api';
import { ApiHttpResponse, Workout } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class ExternalWorkoutApi implements IWorkoutApi {
  constructor(private readonly http: HttpClient) { }

  getWorkouts(
    page: number,
    limit: number,
    userId: number
  ): Observable<ApiHttpResponse<Workout[]>> {
    const params: HttpParams = new HttpParams()
      .set('page', page)
      .set('limit', limit);
    const url: string = environment.api.externalUser.workouts.replace(
      '{userId}',
      '' + userId
    );
    return this.http.get<ApiHttpResponse<Workout[]>>(url, { params });
  }
}
